import Component from "@lib/Component.js";
import { addEvent, gebc } from "@qneyraud/q-utils/umd/q-utils";
import gsap from "gsap";

export default class AgentAffiliate extends Component {
  init() {
    super.init();
    this.bindMethods();
    this.initListeners();

    this.buttonEnabled = true;
    this.expanded = false;

    this.defaultTimelineParams = {
      onStart: () => {
        // avoid spam during animation
        this.buttonEnabled = false;
      },
      onComplete: () => {
        this.buttonEnabled = true;
        this.expanded = !this.expanded;
      }
    };
  }

  bindMethods() {
    this.onExpandClick = this.onExpandClick.bind(this);
  }

  initListeners() {
    addEvent(this.refs["expand-button"], "click", this.onExpandClick);
  }

  onExpandClick() {
    if (!this.buttonEnabled) return;

    if (this.expanded) this.contract();
    if (!this.expanded) this.expand();
  }

  contract() {
    gsap.to(this.refs.main, {
      ...this.defaultTimelineParams,
      duration: 0.5,
      height: 0,
      ease: "power2.inOut"
    });
  }

  expand() {
    gsap
      .timeline()
      .to(this.refs.main, {
        ...this.defaultTimelineParams,
        duration: 0.5,
        height: "auto",
        ease: "power2.inOut"
      })
      .fromTo(
        gebc(this.refs.main, "agent-affiliate-contact-block", true),
        {
          y: 20,
          autoAlpha: 0
        },
        {
          y: 0,
          duration: 0.3,
          autoAlpha: 1,
          stagger: 0.1,
          ease: "power2.inout"
        },
        "-=0.2"
      );
  }
}



// WEBPACK FOOTER //
// ./scripts/components/AgentAffiliate.js